import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-admin-validate-company',
  templateUrl: './admin-validate-company.component.html',
  styleUrls: ['./admin-validate-company.component.css']
})
export class AdminValidateCompanyComponent implements OnInit {

  businesses: any = [];
  authToken = localStorage.getItem('auth');
  isLoading = false;
  selectedBusiness: any;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) {
  }

  ngOnInit(): void {
    this.fetchCompanies();
  }


  fetchCompanies() {
    this.http.get(environment.ADMIN_TEMP_BUSINESSES, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.businesses = res.message;
          console.log('businesses', this.businesses)

        }
        else {
          console.log('ei ole kyseistä käyttäjää')
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  selectBusiness(business) {
    this.selectedBusiness = business;
  }

  rejectBusiness() {
    this.isLoading = true;
    this.http.post(environment.ADMIN_REJECT_BUSINESS, { id: this.selectedBusiness._id }, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.isLoading = false;
          this.fetchCompanies();
          this.selectedBusiness = null;
          document.getElementById('close_reject').click();
        }
        else {
          console.log('ei ole kyseistä käyttäjää')
        }

      }, (err: any) => {
        this.isLoading = false;
        console.log("Error while finding status :: ", err);
      })
  }

  acceptBusiness() {
    var businessID = (<HTMLInputElement>document.getElementById('path')).value;
    var is_public = false;
    var pub_leaver = (<HTMLInputElement>document.getElementById('public_leaver')).checked.toString();
    if(pub_leaver == 'true') {
      is_public = true;
    }
    else {
      is_public = false;
    }

      //Check if businessID contains special characters
      var regex = /^[a-zA-Z0-9]*$/;
      if(!regex.test(businessID)){
        alert('Yrityksen ID ei saa sisältää erikoismerkkejä');
        this.isLoading = false;
        return;
      }
      //Check if contains spaces
      if(businessID.indexOf(' ') >= 0){
        alert('Yrityksen ID ei saa sisältää välilyöntejä');
        this.isLoading = false;
        return;
      }

    var req = {
      businessName: this.selectedBusiness.businessName,
      email: this.selectedBusiness.user.email,
      phone: this.selectedBusiness.user.phone,
      ovt: '',
      operator: '',
      businessID: businessID,
      public_leaver: is_public,
      vatID: this.selectedBusiness.vatID,
      user: {
        email: this.selectedBusiness.user.email,
        phone: this.selectedBusiness.user.phone,
        firstName: this.selectedBusiness.user.firstName,
        lastName: this.selectedBusiness.user.lastName
      },
      prh: this.selectedBusiness.prh,
      temp_business_id: this.selectedBusiness._id
    }


    this.http.post(environment.ADMIN_ACCEPT_BUSINESS, req, this.httpOptions).subscribe(
      (res: any) => {
        this.isLoading = false;
        if(res.status == 200 ) {
          this.router.navigate(['/admins/admin/companies/company/company-details/'+req.businessID]);
          document.getElementById('close_accept').click();

        }
        else {
          alert(res.message);
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }
  
}
